import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tenant-banner flex justify-content-between h-2rem bg-yellow-light p-1 align-content-center" }
const _hoisted_3 = { class: "w-full flex align-items-center text-sm text-color-orange-dark" }
const _hoisted_4 = {
  key: 1,
  class: "text-left font-bold ml-1",
  color: "yellow"
}
const _hoisted_5 = { class: "white-space-nowrap ml-2 line-height-1" }

import { onMounted, ref } from 'vue';
import { VueCookieNext } from 'vue-cookie-next';
import { storeToRefs } from 'pinia';
import { useRouting } from '@/composables';
import { useAuthStore, useTenantStore } from '@/store';
import { TenantInterface } from '@/types/Auth';


export default /*@__PURE__*/_defineComponent({
  __name: 'ImpersonateTenant',
  setup(__props) {

const $routing = useRouting();
const tenantStore = useTenantStore();
const authStore = useAuthStore();
const tenant = ref({} as TenantInterface);
const { token, impersonateTenantToken, isSwitchTenant } = storeToRefs(authStore);

onMounted(() => init());

const init = async () => {
  if (isSwitchTenant.value) {
    tenant.value = impersonateTenantToken?.value?.guest_tenant;
  }
};

const onLeave = async () => {
  const tenantGuest = impersonateTenantToken?.value?.guest_tenant;
  VueCookieNext.removeCookie('tenant');
  const accessToken = VueCookieNext.getCookie('accessToken');
  authStore.setCookie('tenant', accessToken.tenant, token.value?.expires_in);

  await tenantStore.leaveTenant(tenantGuest.id);
  authStore.impersonateTenantToken = null;

  await authStore.getAuthUserProfile();
  $routing.router.push(`/admin`);

  await authStore.fetchAccessToken();
  await authStore.boot();
  document.body.classList.add('theme-admin');
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_unref(isSwitchTenant) && tenant.value.name)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!_unref(authStore).isImpersonating)
              ? (_openBlock(), _createBlock(_component_AppButton, {
                  key: 0,
                  type: "link",
                  color: "yellow",
                  text: "Admin Panel",
                  "icon-left": "arrow_back",
                  style: {"height":"2rem"},
                  onClick: onLeave
                }))
              : (_openBlock(), _createElementBlock("p", _hoisted_4, "Viewing Tenant")),
            _createElementVNode("p", _hoisted_5, _toDisplayString(tenant.value.name), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})